<template>
    <div class="footer">
        <div class="col" id="footer-col">
            <div class="col-content">
                <div class="title">
                    <div class="title-style">最新动态</div>
                </div>
                <div class="col-main">
                    <div class="row">
                        04-24-2020  设备运维管理平台V1.0上线
                    </div>
                    <div class="row">
                        12-05-2019   工业互联网平台V1.2上线
                    </div>
                    <div class="row">
                        08-16-2019   工业物联网平台V2.0上线
                    </div>
                    <div class="row">
                        06-10-2019   工业互联网平台V1.0上线
                    </div>
                    <div class="row">
                        07-12-2019   工业物联网平台V1.0上线
                    </div>
                </div>
            </div>
            <div class="col-content" id="footer-contact-us">
                <div class="title">
                    <div class="title-style">联系我们</div>
                </div>
                <div class="col-main">
                    <div class="row">
                        企业邮箱：
                        <div class="row-content">market@dicode.cn</div>
                    </div>
                    <div class="row">
                        公司地址：
                        <div class="row-content">
<!--                            浙江省杭州市经济技术开发区白杨街道-->
<!--                            6号大街452号2幢D406-407-->
                            杭州市钱塘新区高科技企业孵化器2幢4楼D楼
                        </div>
                    </div>
                </div>

            </div>
            <div class="col-content">
                <div class="title">
                    <div class="title-style-center">关注我们</div>
                </div>
                <div class="col-main">
                    <img src="../../../../assets/index/img/qrcode/二维码.png">
                    <div class="title">
                        <div class="title-style1">
                            杭州鼎研科技有限公司
                        </div>
                    </div>
                </div>
            </div>
        </div>


        <div class="bottom">
            <div class="bottom-content">
                备案号 2020杭州鼎研科技有限公司 版权所有
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "footerInfo",
        data(){
            return{
                width:document.body.clientWidth
            }
        },
        created(){
            this.width=document.body.clientWidth
        },
        mounted(){
            window.addEventListener('resize', this.handelWidth, false)
            this.handelWidth()
        },
        beforeDestroy(){
            window.removeEventListener("resize",this.handelWidth, false)
        },
        methods:{
            handelWidth(){
                this.width=document.body.clientWidth
                let w=document.body.clientWidth
                let footerCol=document.getElementById("footer-col")
                let footerContactUs=document.getElementById("footer-contact-us")
                if(w>1578){
                    footerCol.style.paddingRight="1%"
                    footerCol.style.paddingLeft="20%"
                    // footerContactUs.forEach(item=>{item.style.width="30%"})
                }else if (1443<w&&w<=1578){
                    footerCol.style.paddingRight="1%"
                    footerCol.style.paddingLeft="15%"
                    // footerContactUs.forEach(item=>{item.style.width="30%"})
                }else if (1139<w&&w<=1443){
                    footerCol.style.paddingRight="1%"
                    footerCol.style.paddingLeft="5%"
                    footerContactUs.style.width="400px"
                }else {
                    footerCol.style.paddingRight="1%"
                    footerCol.style.paddingLeft="5%"
                    footerContactUs.style.width="400px"
                }


            }
        }

    }
</script>

<style scoped>
    .footer{
        opacity:1;
        position: relative;
        height:320px;
        background:rgba(15,19,38,1);

    }
    .col{
        position: absolute;
        padding-left: 25%;
        padding-right: 1%;
        height: 260px;
        top: 20px;
    }
    .col-content{
        float: left;
        width: 30%;
        height: 100%;
    }
    .bottom{
        position: absolute;
        top: 282px;
        width: 100%;
    }
    .bottom-content{
        margin:0 auto;
        width:272px;
        height:18px;
        font-size:13px;
        font-family:Alibaba PuHuiTi;
        font-weight:400;
        line-height:18px;
        color:rgba(230,230,230,1);
        letter-spacing:0px;
        opacity:1;
        position: relative;
    }
    .title{
        position: relative;
        top: 20px;
        width: 100%;
    }
    .title-style{
        width:84px;
        height:27px;
        font-size:20px;
        font-family:Alibaba PuHuiTi;
        font-weight:500;
        line-height:27px;
        color:rgba(255,255,255,1);
        letter-spacing:1px;
        opacity:1;
    }
    .title-style1{
        margin: 0 auto;
        width:130px;
        height:17px;
        font-size:12px;
        font-family:Alibaba PuHuiTi;
        font-weight:400;
        line-height:17px;
        color:rgba(255,255,255,1);
        letter-spacing:1px;
        opacity:1;
    }
    .title-style-center{
        margin: 0 auto;
        width:84px;
        height:27px;
        font-size:20px;
        font-family:Alibaba PuHuiTi;
        font-weight:500;
        line-height:27px;
        color:rgba(255,255,255,1);
        letter-spacing:1px;
        opacity:1;
    }
    .col-main{
        position: relative;
        top: 60px;
        width: 100%;
        padding-right: 10px;
    }
    .qrcode{
        margin: 0 auto;
    }
    .row{
        margin: 12px auto;
        height:18px;
        font-size:14px;
        font-family:Alibaba PuHuiTi;
        font-weight:400;
        line-height:20px;
        color:rgba(204,204,204,1);
        letter-spacing:1px;
        opacity:1;
    }
    .row-content{
        width: 256px;
        text-align:left;
    }

</style>
